import { notificationMiddleWare } from "utils/NotificationMiddleWare";
import { apiBase } from "APIs/index";

export const AI_getAnnouncementList = apiBase.createListInstance({
    endpoint: "/get-publicAnnouncement/",
    method: "get",
    reducer: "announcementReducer",
    key: "id",
    reduxKey: "AnnouncementData",
    listPath: "data.rows",
    action: "GET_ANNOUCEMENT_LIST",
    onSuccess: (data) => data.publicAnnouncement,
  });
  

export const AI_getPopupAnnouncementList = apiBase.createListInstance({
    endpoint: "/publicPopupAnnouncement/",
    method: "get",
    reducer: "announcementReducer",
    key: "id",
    reduxKey: "AnnouncementPopupData",
    listPath: "data.rows",
    action: "GET_ANNOUCEMENTPOPUP_LIST",
    onSuccess: (data) => data,
  });

  export const AI_UpdatePopupAnnouncementList = apiBase.createListInstance({
    endpoint: "/publicPopupAnnouncementUpdate/",
    method: "put",
    reducer: "announcementReducer",
    key: "id",
    reduxKey: "AnnouncementUpdatePopupData",
    listPath: "data.rows",
    action: "GET_ANNOUCEMENT_UPDATE_POPUP_LIST",
    
  });

export const AI_deleteAnnouncement = apiBase.createInstance({
    endpoint: "/publicAnnouncement",
    method: "delete",
    reducer: "announcementReducer",
    reduxKey: "deleteAnnouncementData",
    action: "DELETE_ANNOUCEMENT",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getAnnouncementList.deleteAction(
            data.deleted_id
        )
    }
});

export const AI_addAnnouncement = apiBase.createInstance({
    endpoint: "/publicAnnouncement",
    method: "post",
    reducer: "announcementReducer",
    reduxKey: "addAnnouncementData",
    action: "ADD_ANNOUCEMENT",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getAnnouncementList.updateAction(
            data.publicAnnouncement
        )
    }
});

export const AI_updateAnnouncement = apiBase.createInstance({
    endpoint: "/publicAnnouncement/{id}",
    method: "put",
    reducer: "announcementReducer",
    reduxKey: "updateAnnouncementData",
    action: "UPDATE_ANNOUCEMENT",
    middleware : notificationMiddleWare,
    listPath:"data.rows",
    onSuccess: (data) => {
        AI_getAnnouncementList.updateAction(
            [
                data.publicAnnouncement
            ]
        )
    }
});

